import { useQuery } from "@apollo/client";
import { useAuth0 } from "@auth0/auth0-react";
import { constantsData, urlsData } from "data";
import { getUserQuery } from "graph";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { openAlert } from "redux/actions";
import { displayErrorHandler } from "utils";

const useGetUser = (id) => {
    const { isAuthenticated } = useAuth0();

    const { t } = useTranslation();

    const navigate = useNavigate();

    const dispatch = useDispatch();

    const {
        data,
        error,
        loading,
    } = useQuery(
        getUserQuery,
        {
            onCompleted: ({ user }) => {
                if (!user) navigate(urlsData.routes.notFound);
            },
            skip: !isAuthenticated,
            variables: { id },
        },
    );

    useEffect(
        () => {
            if (error?.message === constantsData.failedToFetch && !loading) {
                displayErrorHandler(
                    t("messages.networkFailure"),
                    dispatch,
                    openAlert,
                );
            }
        },
        [error, data], // eslint-disable-line
    );

    return {
        data: data?.user,
        loading,
    };
};

export default useGetUser;
